import cls from "./PartnerRequestInbox.module.scss";

function RequestItem({
  title,
  description,
  actions = null,
  tone = "default",
}) {
  return (
    <div className={`${cls.item} ${tone === "inbound" ? cls.inbound : cls.outbound}`}>
      <div className={cls.itemText}>
        <div className={cls.itemTitle}>{title}</div>
        <div className={cls.itemDescription}>{description}</div>
      </div>

      {actions ? <div className={cls.actions}>{actions}</div> : null}
    </div>
  );
}

export default function PartnerRequestInbox({
  inbox,
  loading = false,
  onAccept,
  onReject,
  onCancel,
  actionLoadingId = "",
}) {
  const inbound = inbox?.inboundPendingRequests || [];
  const outbound = inbox?.outboundPendingRequests || [];
  const currentPartner = inbox?.currentPartner || null;
  const hasInbound = inbound.length > 0;
  const hasOutbound = outbound.length > 0;

  return (
    <section className={cls.section}>
      <div className={cls.card}>
        <div className={cls.cardHead}>
          <div>
            <p className={cls.eyebrow}>PARTNER LINK</p>
            <h3 className={cls.title}>Partner status</h3>
          </div>
        </div>

        <p className={cls.statusText}>
          {currentPartner
            ? `You are partnered with #${currentPartner.playerNo} ${currentPartner.displayName}.`
            : "You are not partnered yet."}
        </p>
      </div>

      {hasInbound ? (
        <div className={cls.card}>
          <div className={cls.cardHead}>
            <div>
              <p className={cls.eyebrow}>INCOMING</p>
              <h3 className={cls.title}>Incoming requests</h3>
            </div>
          </div>

          <div className={cls.list}>
            {inbound.map((request) => {
              const player = request.counterparty;

              return (
                <RequestItem
                  key={request._id}
                  tone="inbound"
                  title={`#${player?.playerNo || "--"} ${player?.displayName || "Unknown player"}`}
                  description="This player wants to partner with you."
                  actions={
                    <>
                      <button
                        type="button"
                        className={`${cls.actionButton} ${cls.acceptButton}`}
                        disabled={loading || actionLoadingId === request._id}
                        onClick={() => onAccept?.(request)}
                      >
                        Accept
                      </button>

                      <button
                        type="button"
                        className={`${cls.actionButton} ${cls.rejectButton}`}
                        disabled={loading || actionLoadingId === request._id}
                        onClick={() => onReject?.(request)}
                      >
                        Reject
                      </button>
                    </>
                  }
                />
              );
            })}
          </div>
        </div>
      ) : null}

      {hasOutbound ? (
        <div className={cls.card}>
          <div className={cls.cardHead}>
            <div>
              <p className={cls.eyebrow}>SENT</p>
              <h3 className={cls.title}>Sent requests</h3>
            </div>
          </div>

          <div className={cls.list}>
            {outbound.map((request) => {
              const player = request.counterparty;

              return (
                <RequestItem
                  key={request._id}
                  tone="outbound"
                  title={`#${player?.playerNo || "--"} ${player?.displayName || "Unknown player"}`}
                  description="Waiting for this player to accept or reject your request."
                  actions={
                    <button
                      type="button"
                      className={`${cls.actionButton} ${cls.cancelButton}`}
                      disabled={loading || actionLoadingId === request._id}
                      onClick={() => onCancel?.(request)}
                    >
                      Cancel request
                    </button>
                  }
                />
              );
            })}
          </div>
        </div>
      ) : null}
    </section>
  );
}